import Component from '@glimmer/component';
import { action } from '@ember/object';
import { set } from '@ember/object';

export default class LevelSelectorComponent extends Component {
  @action
  removeColor(contact, event) {
    event.preventDefault();
    set(contact, 'tmpLevel', null);
    this.args.setLevel(contact, this.args?.dispo, null);
  }

  @action
  setColor(contact, level, event) {
    event.preventDefault();
    set(contact, 'tmpLevel', level);
    this.args.setLevel(contact, this.args?.dispo, level);
  }

  @action
  toggleSottoLivelli(level, event) {
    event.preventDefault();
    set(level, 'showSottoLivelli', !level.showSottoLivelli);
  }
}
